import React from 'react';
import { useTranslation } from 'react-i18next';

import { CollapsableSection } from '../../../components/collapsable-section';
import { OptionLabels } from '../../../components/option-labels';
import { ReferencePointTransformMode } from '../reference-point-transform';

type Props = {
  mode: ReferencePointTransformMode;
  setMode: (mode: ReferencePointTransformMode) => void;
};

export const ModeSection = (props: Props) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = React.useState(true);

  return (
    <CollapsableSection
      expanded={expanded}
      title={t('section.scalingMode.text', { ns: 'skyviewScale' })}
      onSetExpanded={(state) => setExpanded(state)}
    >
      <OptionLabels
        active={props.mode}
        itemRows={[
          [
            {
              title: t('section.scalingMode.knownCoordinates.text', { ns: 'skyviewScale' }),
              value: 'coordinates',
              tooltipText: t('section.scalingMode.knownCoordinates.tooltip', {
                ns: 'skyviewScale',
              }),
              onSelect: () => {
                props.setMode('coordinates');
              },
            },
          ],
          [
            {
              title: t('section.scalingMode.referenceLength.text', { ns: 'skyviewScale' }),
              value: 'length',
              tooltipText: t('section.scalingMode.referenceLength.tooltip', { ns: 'skyviewScale' }),
              onSelect: () => {
                props.setMode('length');
              },
            },
          ],
        ]}
      />
    </CollapsableSection>
  );
};
